import { render, staticRenderFns } from "./ReportPageFeedback.vue?vue&type=template&id=17cf6502&scoped=true&"
import script from "./ReportPageFeedback.vue?vue&type=script&lang=js&"
export * from "./ReportPageFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cf6502",
  null
  
)

export default component.exports